import styled from "styled-components";
import logoalt from "../../../icons/logoalt.svg";
import headerAlarm from "../../../icons/headerAlarm.svg";
import user from "../../../icons/user.svg";
import { UIWidgetsDiv } from "../division/Division";

const UIWidgetsSubHeader = styled(UIWidgetsDiv)`
  font: inherit;
  position: relative;
  height: 69px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15), 0 6px 20px 0 rgba(0, 0, 0, 0.02);
  align-items: center;
  & > div > div:first-child > div:first-child {
    width: auto;
  }
  & > div > div:first-child {
    justify-content: space-between;
  }
`;

export const UIWidgetsLogo = styled.div`
  background-image: url(${logoalt});
  width: 142px;
  height: 39px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  margin-left: 24px;
`;

export const UIWidgetsTabs = styled(UIWidgetsDiv)`
  flex-direction: row;
  justify-content: center;
  & > div {
    text-align: center;
    &:active {
      border-bottom: 2px solid;
      border-color: ${props => props.theme.brandBlue};
    }
  }
`;

export const UIWidgetsAlarm = styled.div`
  background-image: url(${headerAlarm});
  width: 18px;
  height: 18px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  margin-left: 24px;
`;

export const UIWidgetsUser = styled.div`
  background-image: url(${user});
  width: 28px;
  height: 28px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  margin-left: 24px;
`;

export const UIWidgetsSubHeaderRightWrapper = styled(UIWidgetsDiv)`
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;

export default UIWidgetsSubHeader;
